// pages/resources/ResourceLibrary.jsx
import { useState } from 'react';

export default function ResourceLibrary() {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');
  const [sortBy, setSortBy] = useState('newest');

  const filters = ['All', 'Guide', 'Case Study', 'Report', 'Video', 'Template', 'eBook'];

  const resources = [
    {
      title: "Complete Guide to Facebook Ads",
      description: "Master Facebook advertising with proven strategies, targeting techniques, and optimization tips",
      type: "Guide",
      count: "12 Resources",
      downloads: "2.3k",
      rating: 4.8,
      duration: "15 min read",
      featured: true,
      tags: ["Facebook", "Social Media", "Beginner"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      title: "E-commerce Success Stories 2025",
      description: "Real-world case studies from brands that achieved 300%+ ROAS through strategic campaign optimization",
      type: "Case Study",
      count: "8 Stories",
      downloads: "1.8k",
      rating: 4.9,
      duration: "20 min read",
      featured: true,
      tags: ["E-commerce", "Success Stories", "Advanced"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: "Digital Advertising Trends 2026",
      description: "Latest trends, insights, and predictions shaping the future of digital advertising and marketing",
      type: "Report",
      count: "15 Reports",
      downloads: "3.1k",
      rating: 4.7,
      duration: "25 min read",
      featured: false,
      tags: ["Trends", "Research", "Industry"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    {
      title: "AI-Powered Campaign Optimization",
      description: "Watch our expert-led webinar on leveraging AI and machine learning for campaign performance",
      type: "Video",
      count: "20 Videos",
      downloads: "4.2k",
      rating: 4.9,
      duration: "45 min",
      featured: true,
      tags: ["AI", "Webinar", "Optimization"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: "Campaign Planning Templates",
      description: "Professional templates and worksheets to streamline your advertising workflow and planning process",
      type: "Template",
      count: "10 Templates",
      downloads: "2.7k",
      rating: 4.6,
      duration: "Instant download",
      featured: false,
      tags: ["Templates", "Planning", "Tools"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
    {
      title: "Advanced Google Ads Strategies",
      description: "In-depth eBook covering advanced Google Ads techniques, bidding strategies, and ROI optimization",
      type: "eBook",
      count: "6 Books",
      downloads: "1.5k",
      rating: 4.8,
      duration: "2 hour read",
      featured: false,
      tags: ["Google Ads", "Advanced", "Strategy"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      title: "Social Media Advertising Playbook",
      description: "Complete playbook for running successful social media campaigns across all major platforms",
      type: "Guide",
      count: "12 Resources",
      downloads: "3.4k",
      rating: 4.7,
      duration: "30 min read",
      featured: false,
      tags: ["Social Media", "Multi-Platform", "Guide"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      )
    },
    {
      title: "SaaS Marketing Success Stories",
      description: "How leading SaaS companies scaled their user acquisition through paid advertising",
      type: "Case Study",
      count: "8 Stories",
      downloads: "2.1k",
      rating: 4.9,
      duration: "18 min read",
      featured: false,
      tags: ["SaaS", "B2B", "Growth"],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    }
  ];

  const stats = [
    { 
      label: "Total Resources", 
      value: "500+", 
      icon: (
        <svg className="w-8 h-8 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      )
    },
    { 
      label: "Downloads", 
      value: "50k+", 
      icon: (
        <svg className="w-8 h-8 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
        </svg>
      )
    },
    { 
      label: "Active Users", 
      value: "10k+", 
      icon: (
        <svg className="w-8 h-8 text-[#00809D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    },
    { 
      label: "Avg Rating", 
      value: "4.8", 
      icon: (
        <svg className="w-8 h-8 text-[#00809D]" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      )
    }
  ];

  const filteredResources = resources.filter(resource => {
    const matchesFilter = activeFilter === 'All' || resource.type === activeFilter;
    const matchesSearch = resource.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         resource.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         resource.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesFilter && matchesSearch;
  });

  const featuredResources = resources.filter(r => r.featured);

  return (
    <div className="min-h-screen bg-black pt-20 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#00809D] to-[#00a0c4] rounded-2xl mb-6 shadow-2xl shadow-[#00809D]/50">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4">
            Resource Library
          </h1>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Explore our collection of guides, case studies, and insights to accelerate your advertising success
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-4 sm:p-6 text-center hover:border-[#00809D]/50 transition-all group">
              <div className="flex items-center justify-center mb-3 group-hover:scale-110 transition-all">
                {stat.icon}
              </div>
              <p className="text-2xl sm:text-3xl font-bold text-[#00809D] mb-1">{stat.value}</p>
              <p className="text-gray-400 text-xs sm:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Search and Filters */}
        <div className="mb-12">
          {/* Search Bar */}
          <div className="mb-6 max-w-3xl mx-auto">
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search guides, templates, case studies..."
                className="w-full bg-gradient-to-br from-gray-900 to-black border border-white/20 rounded-2xl px-6 py-4 pl-14 text-white text-base sm:text-lg placeholder-gray-500 focus:border-[#00809D] focus:outline-none transition-colors shadow-lg"
              />
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-gray-400 absolute left-5 top-1/2 -translate-y-1/2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-medium transition-all text-sm sm:text-base ${
                  activeFilter === filter
                    ? 'bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white shadow-lg shadow-[#00809D]/50 scale-105'
                    : 'bg-gray-900 text-gray-400 border border-white/10 hover:border-[#00809D]/50 hover:text-white hover:scale-105'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>

          {/* Sort */}
          <div className="flex items-center justify-center gap-3 text-sm">
            <span className="text-gray-400">Sort by:</span>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="bg-gray-900 border border-white/10 rounded-xl px-4 py-2 text-white focus:border-[#00809D] focus:outline-none transition-colors cursor-pointer"
            >
              <option value="newest">Newest First</option>
              <option value="popular">Most Popular</option>
              <option value="rating">Highest Rated</option>
              <option value="downloads">Most Downloaded</option>
            </select>
          </div>
        </div>

        {/* Featured Resources */}
        {activeFilter === 'All' && !searchQuery && (
          <div className="mb-16">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8 flex items-center gap-3">
              <svg className="w-6 h-6 sm:w-8 sm:h-8 text-[#00809D]" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
              Featured Resources
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
              {featuredResources.map((resource, index) => (
                <div
                  key={index}
                  className="group bg-gradient-to-br from-[#00809D]/10 to-[#00a0c4]/5 border border-[#00809D]/30 rounded-3xl p-6 sm:p-8 hover:border-[#00809D]/50 transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl hover:shadow-[#00809D]/20"
                >
                  <div className="flex items-start gap-4 sm:gap-6">
                    <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#00809D] to-[#00a0c4] rounded-2xl flex items-center justify-center text-white shadow-lg shadow-[#00809D]/50 group-hover:scale-110 transition-all">
                      {resource.icon}
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-wrap items-center gap-2 mb-3">
                        <span className="px-3 py-1 bg-[#00809D]/30 text-[#00809D] rounded-full text-xs font-semibold">
                          {resource.type}
                        </span>
                        <span className="px-3 py-1 bg-yellow-500/20 text-yellow-400 rounded-full text-xs font-semibold flex items-center gap-1">
                          <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                          </svg>
                          Featured
                        </span>
                      </div>
                      <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 group-hover:text-[#00809D] transition-colors">
                        {resource.title}
                      </h3>
                      <p className="text-gray-300 mb-4 leading-relaxed text-sm sm:text-base">
                        {resource.description}
                      </p>
                      <div className="flex flex-wrap items-center gap-4 text-xs sm:text-sm text-gray-400 mb-4">
                        <span className="flex items-center gap-1">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          {resource.duration}
                        </span>
                        <span className="flex items-center gap-1">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                          </svg>
                          {resource.downloads} downloads
                        </span>
                        <span className="flex items-center gap-1">
                          <svg className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                          </svg>
                          {resource.rating}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2 mb-4">
                        {resource.tags.map((tag, i) => (
                          <span key={i} className="px-2 py-1 bg-gray-800 text-gray-300 rounded text-xs">
                            {tag}
                          </span>
                        ))}
                      </div>
                      <button className="bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-6 py-3 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50 flex items-center gap-2 text-sm sm:text-base">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                        </svg>
                        Download Now
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* All Resources Grid */}
        <div className="mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8">
            {searchQuery ? `Search Results (${filteredResources.length})` : 'All Resources'}
          </h2>
          {filteredResources.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {filteredResources.map((resource, index) => (
                <div
                  key={index}
                  className="group bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-6 sm:p-8 hover:border-[#00809D]/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#00809D]/20"
                >
                  <div className="flex items-center justify-between mb-4">
                    <span className="px-3 py-1 bg-[#00809D]/20 text-[#00809D] rounded-full text-xs sm:text-sm font-semibold">
                      {resource.type}
                    </span>
                    <div className="flex items-center gap-1 text-yellow-400 text-xs sm:text-sm">
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                      <span className="font-semibold">{resource.rating}</span>
                    </div>
                  </div>

                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#00809D] to-[#00a0c4] rounded-xl flex items-center justify-center text-white mb-4 shadow-lg shadow-[#00809D]/30 group-hover:scale-110 transition-all">
                    {resource.icon}
                  </div>

                  <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 group-hover:text-[#00809D] transition-colors">
                    {resource.title}
                  </h3>
                  <p className="text-gray-400 mb-4 leading-relaxed text-sm sm:text-base">
                    {resource.description}
                  </p>

                  <div className="flex items-center gap-4 text-xs sm:text-sm text-gray-400 mb-4">
                    <span className="flex items-center gap-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {resource.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                      </svg>
                      {resource.downloads}
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-4">
                    {resource.tags.slice(0, 3).map((tag, i) => (
                      <span key={i} className="px-2 py-1 bg-gray-800 text-gray-300 rounded text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>

                  <button className="w-full text-[#00809D] font-semibold flex items-center justify-center gap-2 group-hover:gap-3 transition-all text-sm sm:text-base py-2">
                    View Resource
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-3xl">
              <div className="w-20 h-20 bg-gray-800/50 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <p className="text-gray-400 text-lg mb-2">No resources found</p>
              <p className="text-gray-500 text-sm">Try different keywords or filters</p>
              <button
                onClick={() => {
                  setSearchQuery('');
                  setActiveFilter('All');
                }}
                className="mt-6 text-[#00809D] font-semibold hover:text-[#00a0c4] transition-colors"
              >
                Clear all filters
              </button>
            </div>
          )}
        </div>

        {/* CTA Section */}
        <div className="text-center bg-gradient-to-r from-[#00809D]/10 to-transparent border border-[#00809D]/30 rounded-3xl p-8 sm:p-12">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Can't find what you're looking for?
            </h3>
            <p className="text-gray-400 mb-8 text-base sm:text-lg">
              Our team is here to help you find the perfect resources for your needs
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-8 py-4 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50 flex items-center justify-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Contact Us
              </button>
              <button className="bg-gray-800 text-white px-8 py-4 rounded-xl font-semibold hover:bg-gray-700 transition-all flex items-center justify-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
                Subscribe for Updates
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
